import ru from './ru'
import en from './en'
import ro from './ro'
import de from './de'
import tr from './tr'
export default {
  ru, // 👈 важно, чтобы было в виде { ru: {...}, en: {...} }
  en, ro, de, tr
}
